<template>
  <v-card flat :class="component_class">
    <slot name="controls"> </slot>
    <v-card-title v-if="show_header_bar">
      <slot name="left_actions"> </slot>
      <v-text-field
        v-if="show_search"
        v-model="search"
        :append-icon="search_icon"
        single-line
        hide-details
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        filled
        autocomplete="off"
        :label="search_label"
        :disabled="disabled"
        :rules="validation_rules"
        :required="required"
        :type="type"
        :readonly="readonly"
      ></v-text-field>
      <slot name="actions"> </slot>
    </v-card-title>
    <div v-if="show_description">
      <slot name="description">
        {{ description }}
      </slot>
    </div>
    <v-card-text class="pa-0 pl-0">
      <v-data-table
        :headers="headers"
        :items="items"
        xoptions.sync="options"
        xserver-items-length="totalDesserts"
        :loading="is_loading"
        :loading-text="loading_text"
        :search="search"
        class="elevation-1 pointer"
        :fixed-header="true"
        item-class="pointer"
        :height="height"
        :hide-default-footer="!show_footer"
      >
      
        <template
          v-for="(_, name) in $scopedSlots"
          :slot="name"
          slot-scope="slotData"
          ><slot :name="name" v-bind="slotData"
        /></template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CardedTable",
  props: {
    has_margin: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: 550,
    },
    show_description: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: "",
    },
    loading_text: {
      type: String,
      default: "Loading... Please wait",
    },
    search_label: {
      type: String,
      default: "Search",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    show_footer: {
      type: Boolean,
      default: true,
    },
    show_header_bar: {
      type: Boolean,
      default: true,
    },
    show_search: {
      type: Boolean,
      default: true,
    },
    search_icon: {
      type: String,
      default: "mdi-magnify",
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    headers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => {
    return {
      search: "",
    };
  },
  computed: {
    component_class(){
      var cls = "ma-5 pl-0 pr-0 pt-0 elevation-4";
      if(this.has_margin == false){
        cls = "pl-0 pr-0 pt-0 elevation-4";
      }
      return cls;
    }
  }
};
</script>